import React from 'react';
import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';

const ProductGradeChip = props => {
  const { value } = props;
  return value ? (
    <Chip
      label={value}
      sx={{
        '& .MuiChip-label': {
          color: value === 'ALL' ? 'text.secondary' : 'primary.dark',
        },
        backgroundColor: value === 'ALL' ? 'graphic.light' : 'primary.light',
        height: 20,
        typography: 'caption',
      }}
    />
  ) : null;
};

ProductGradeChip.defaultProps = {
  value: '',
};

ProductGradeChip.propTypes = {
  value: PropTypes.string,
};

export default ProductGradeChip;
